/**
 * Determine if the provided value is a valid number. A valid number:
 *   1. Is type 'number'
 *   2. Is finite
 *   3. Is not NaN
 * @param value The value to check
 * @returns {boolean} If the value is a valid number
 */
export const isValidNumber = (value: unknown): value is number => {
  return typeof value === 'number' && isFinite(value) && !isNaN(value);
};
